import { createContext } from 'react'

import { AgentVerificationDecisionContextType } from './AgentVerificationDecisionContext.types'

export const AgentVerificationDecisionContext = createContext<AgentVerificationDecisionContextType | undefined>(
  undefined
)
